module.exports = __webpack_public_path__ + "media/images/new/placeholder-149f4b80bab42add3957085c9e9c016d.png";